// extracted by mini-css-extract-plugin
module.exports = {"comp":"ProductNav_comp__qwYLR"};